import { render, staticRenderFns } from "./TelefonBezeichnung.vue?vue&type=template&id=099c04f5"
import script from "./TelefonBezeichnung.vue?vue&type=script&lang=js"
export * from "./TelefonBezeichnung.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports